export const pos = {
	title: "Dispositivos: PDVs y Tótems del Evento",
	open: "{{active}} de {{total}} PDV´s abiertos",
	info:
		"Es necesario que el PDV esté conectado a internet para sincronización de las configuraciones.",
	searchPlaceholder: "Buscar dispositivo o empleado",
	noName: "Sin nombre",
	error: "Esta operación solo está permitida cuando no hay ningún PDV seleccionado",
	editConfig: {
		label: "Editar Configuraciones",
		title: "Modificar PDVs ({{count}})",
		configs: {
			label: "Configuraciones",
			checkbox: "Intentar emparejar terminal bluetooth",
		},
		bluetooth: "Bluetooth",
		wifi: "Wi-fi",
		preferences: "Preferencias",
		noName: "Preferencia sin nombre",
		confirmMessage:
			"¿Está seguro que desea guardar los cambios? Tanto el wifi como los datos móviles del(los) dispositivo(s) están deshabilitados, de esta forma no será posible visualizar la información actualizada del dispositivo.",
		errorMessage:
			"Una de estas preferencias 'Habilitar venta' y 'Habilitar venta en grupo' debe estar activa",
	},
	columns: {
		fingerPrint: "CÓDIGO",
		product: "PRODUCTO",
		version: "VERSIÓN",
		employee: "COLABORADOR",
		activation: "ACTIVACIÓN",
		lastUpdate: "ÚLTIMA ACTUALIZACIÓN",
		cleanedDataStatus: "¿LIMPIÓ?",
		hasFinishedActivity: {
			label: "OPERACIÓN",
			finished: "Finalizado",
			open: "Abierto",
		},
		devicePlatform: "MODELO",
		deviceConfig: "ESTADO",
		date: "FECHA",
	},
	deviceConfigColumn: {
		noData: "sin datos",
		on: "encendido",
		off: "apagado",
		tryingToConnect: "Intentando conectar a terminal bluetooth",
		connected: "conectada",
		disconnect: "desconectada",
		bluetooth: "Bluetooth",
		bluetoothMachine: "Terminal bluetooth",
		wifi: "Wifi",
		mobileData: "Datos móviles",
		nfc: "NFC",
	},
	settings: "Configuraciones",
	humanizedPreferencies: {
		dettachOnCheckout: "Desanexar automáticamente en el checkout",
		hidePaymentModeVoucher: "Ocultar modo de pago voucher",
		isGroupedSellEnabled: "Habilitar venta en grupo",
		isKeyboardOpenEnabled: "Teclado ya abierto en la búsqueda",
		isNormalSellEnabled: "Habilitar venta",
		isNumericKeyboardInObsEnabled: "Observación con teclado numérico",
		isSearchByCodeEnabled: "Búsqueda numérica",
		isSellWithoutCardEnabled: "Habilitar venta sin tarjeta",
		isStockTransfEnabled: "Transferir inventario",
		isStorageTransferPrinterLanActive:
			"Activar impresora de transferencia de inventario por LAN",
		printTwoTickets: "Imprimir dos copias de venta",
		printViaBtForWaiter: "Mostrar botón para imprimir pedidos pendientes de meseros",
		registerWithoutCard: "Registro sin tarjeta",
		removeCreditDebitPaymentOption: "Eliminar opción de Débito y Crédito",
		hideDettachOption: "Ocultar desanexar",
	},
};
